var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJamf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79808 0.566381C1.31635 0.568563 0.927529 0.960839 0.929697 1.44259L0.956861 7.47387C0.959028 7.94349 1.34135 8.32249 1.81094 8.3203L4.85073 8.30658C6.24216 8.30037 8.15115 8.00604 8.66468 5.53281C8.66498 5.53222 9.17488 3.05611 9.47715 1.58836C9.58942 1.04247 9.17084 0.533166 8.61352 0.535607L1.79808 0.566381Z",
    fill: "#748AB5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4434 3.37418C11.3907 3.38343 10.1818 4.25327 9.6378 6.11111C9.6388 6.10737 8.22813 10.5354 8.22813 10.5354C7.71043 11.9897 6.86936 12.5918 5.32923 12.5987L1.79573 12.6146C1.34507 12.6166 0.981384 12.9836 0.983407 13.4345L0.993521 15.6878C0.995544 16.1188 1.34651 16.4667 1.77753 16.4648L16.1185 16.4001C16.5683 16.3981 16.9312 16.0318 16.9292 15.5822L16.8776 4.1439C16.8756 3.71027 16.5226 3.36031 16.0888 3.36235L13.4434 3.37418Z",
    fill: "#748AB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJamf);
export default __webpack_public_path__ + "static/media/Jamf.d43d6139a433f42ca569e35ad3e46e32.svg";
export { ForwardRef as ReactComponent };